import { Skeleton } from '@/components';
import { getFunnelsListGridTemplate } from '../../constants/funnelsListColumns';

/**
 * Placeholder row shown at the top of the funnels list while a duplication
 * is in progress. Matches FunnelRow's outer wrapper (p-3 on md+) and
 * StanDataRow's `variant='simple'` inner min-height so the skeleton lines
 * up with a real row height.
 */
export const FunnelRowSkeleton = () => {
    const gridTemplate = getFunnelsListGridTemplate();

    return (
        <div className='bg-canvas shadow-stan! overflow-hidden rounded-lg p-0 md:p-3'>
            <div
                className='grid items-center gap-4 px-6 py-5'
                style={{ gridTemplateColumns: gridTemplate }}
                aria-busy='true'
                aria-label='Duplicating funnel'
            >
                <div className='flex items-center gap-3'>
                    <Skeleton className='size-6 shrink-0 rounded-md' />
                    <Skeleton className='h-4 w-32' />
                </div>
                <Skeleton className='hidden h-4 w-16 md:block' />
                <Skeleton className='hidden h-4 w-8 md:block' />
                <Skeleton className='hidden h-4 w-8 md:block' />
                <Skeleton className='hidden h-4 w-8 md:block' />
                <Skeleton className='hidden h-4 w-48 md:block' />
            </div>
        </div>
    );
};
